import { PropType, PropValidator } from 'vue/types/options';

export function vueProp<T>(type: PropType<T>, defaultValue?: T) {
	return {
		type,
		default: defaultValue,
		required: false,
	} as PropValidator<T>;
}

export function vuePropRequired<T>(type: PropType<T>) {
	return {
		type,
		required: true,
	} as PropValidator<T>;
}
